import React from 'react'

import { Grid } from '@geist-ui/react'
import { Logo } from 'components'

export default function ErrorPage({
  logo = false,
  title = 'Error',
  subheading = 'Error loading data',
  description,
  action,
}) {
  return (
    <Grid.Container
      direction="column"
      justify="center"
      alignItems="center"
      width="100vw"
      height="50vw"
      style={{ padding: '5rem 3rem', textAlign: 'center' }}
    >
      {logo && <Logo />}
      <br />
      <br />
      <div>
        <h6 style={{ margin: 0 }}>{subheading}</h6>
        <h1 style={{ marginTop: '-0.5rem' }}>{title}</h1>
        <p style={{ marginTop: '-0.5rem' }}>{description}</p>
        {action}
      </div>
    </Grid.Container>
  )
}
